import { usePermissions } from "components/context/permissionsContext";

export const useBillingInfoPermission = () => {
  const { userPermissions } = usePermissions();

  const hasBillingSavePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "BillingInfo" &&
      item.action === "Save" &&
      item.hasPermission
  );
  const hasBillingGetPermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "BillingInfo" &&
      item.action === "Get" &&
      item.hasPermission
  );
  const hasBillingDeletePermission = userPermissions.some(
    (item) =>
      item.module === "Customer" &&
      item.controller === "BillingInfo" &&
      item.action === "Delete" &&
      item.hasPermission
  );

  const BillingPermissionProps = {
    hasBillingSavePermission,
    hasBillingGetPermission,
    hasBillingDeletePermission,
  };

  return {
    BillingPermissionProps,
  };
};
